import { type ComponentType, lazy } from 'react';

import type { ScreenName } from '../router';
import Home from './Home';
import Pairing from './Pairing';
import Playlist from './Playlist';
import Profile from './Profile';
import Search from './Search';
import SessionEnded from './SessionEnded';
import type { ScreenProps } from './types';

export type { ScreenProps } from './types';

/**
 * Screen registry. Player is a lazy chunk (docs/04 §6: the adapter/Shaka arrive with it in
 * WP1.7). Add a screen: extend `ScreenName`/`ScreenParams` in ../router and register it here.
 */
export const screens: { [S in ScreenName]: ComponentType<ScreenProps<S>> } = {
  pairing: Pairing,
  sessionEnded: SessionEnded,
  home: Home,
  search: Search,
  profile: Profile,
  playlist: Playlist,
  player: lazy(() => import('./Player')),
};

/** Screens rendered without the rail. */
export const FULLSCREEN_SCREENS: readonly ScreenName[] = ['pairing', 'sessionEnded', 'player'];
